import {
    Container,
    ContainerHeadBasket,
    Root,
    StylePathBox,
    TableAndPrices,
    useClasses,
} from "./BasketPage.styles";
import { Box, IconButton } from "@mui/material";
import PartList, {
    ColumnAlign,
    ColumnWidth,
} from "../../components/PartsList/PartList";
import { useEffect, useRef, useState } from "react";
import ServiceProvider from "../../configuration/ServiceProvider";
import {
    BasketItemDTO,
    BasketItem,
} from "../../../explorer/types/Basket/BasketItems";
import CodeAndDescriptionComponent from "../../components/PartsList/TableLayout/TableColumnComponents/CodeAndDescriptionComponent";
import ReplaceIconComponent from "../../components/PartsList/TableLayout/TableColumnComponents/ReplaceIconComponent";
import AvaibilityIconComponent from "../../components/PartsList/TableLayout/TableColumnComponents/AvaibilityIconComponent";
import QuantityComponent from "../../components/PartsList/TableLayout/TableColumnComponents/QuantityComponent";
import BreadcrumbComponent from "../../components/Breadcrumb/BreadcrumbComponent";
import DiscountComponent from "../../components/PartsList/TableLayout/TableColumnComponents/DiscountComponent";
import DeleteRowComponent from "../../components/PartsList/TableLayout/TableColumnComponents/DeleteRowComponent";
import useLanguages from "../../../explorer/hooks/useLanguages";
import PriceFormatComponent from "../../components/PartsList/TableLayout/TableColumnComponents/PriceFormatComponent";
import { MoreVert } from "@mui/icons-material";
import { BasketPageDotsMenu } from "../../components/Basket/BasketPageDotsMenu";
import BasketHeader from "./BasketHeader";
import BasketTotalPrice from "./BasketTotalPrice";
import { BasketDetail } from "../../../explorer/types/Basket/BasketDetail";
import useBrands from "../../../explorer/hooks/useBrands";
import { Basket } from "../../../explorer/types";
import { useBasket } from "../../hook/useBasket";
import BasketNoItemPage from "./BasketNoItemPage";
import { useApiError } from "../../hook/useApiError";
import { RequestQueue } from "../../services/RequestQueue";
import BasketAddPartByRef from "./BasketAddPartByRef";
import { usePartDetails } from "../../hook/usePartDetails";
import { isPilot } from "../../../explorer/helpers/CommonHelper";
import PartSketchThumbnailComponent from "../../components/PartsList/TableLayout/TableColumnComponents/PartSketchThumbnailComponent";
import { useUserInfo } from "../../../explorer/hooks/useUserInfo";
import { BasketOperations } from "../../components/Basket/BasketOperations";
import { useTranslation } from "../../../explorer/hooks/useTranslation";
import PartMccLogoComponent from "../../components/PartsList/TableLayout/TableColumnComponents/PartMccLogoComponent";
import useCurrentSite from "../../hook/useCurrentSite";
import { usePartFormatter } from "../../hook/usePartFormatter";
import { AppIconsMenuBurger } from "../../components/AppIcons";

// Istanza unica della coda
const requestQueue = new RequestQueue(5);

const BasketPage = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const brand = useBrands().currentBrandUrl;
    const classes = useClasses();
    // Lista di item nel basket
    const [items, setItems] = useState<BasketItem[]>([]);

    // Hook del basket + basket corrente
    const basketHook = useBasket();
    const [currentBasket, setCurrentBasket] = useState<Basket>(
        basketHook.currentBasket
    );
    const [basketDetail, setBasketDetail] = useState<BasketDetail>();

    const [currency,setCurrency] = useState<string>();
    const [showDiscount, setShowDiscount] = useState<boolean>();
    
    // Language
    const { currentLanguage } = useLanguages();
    const [lang, setLang] = useState<string>(currentLanguage);

    const [userInfo] = useUserInfo();
    const [currentSite] = useCurrentSite();

    // Operazioni su singola riga
    const listDisabledRow = useRef<string[]>([]);

    const [loadingPrices, setLoadingPrices] = useState<boolean>(true);
    const { t } = useTranslation();

    const [orderOfferWarrantyAnchorEl, setBasketOrderOfferWarrantyAnchorEl] =
        useState<HTMLButtonElement | null>(null);

    const [basketListActionAnchorEl, setBasketListActionAnchorEl] =
        useState<HTMLButtonElement | null>(null);

    const [loadPrice, setLoadPrice] = useState<NodeJS.Timeout>();
    const previousBasketId = useRef<number | null>(null);
    const [error, setError] = useApiError();

    const { closePartDetails, partDetailsProps, openPartDetails } =
        usePartDetails();
    const [partDetailOpen, setPartDetailOpen] = useState<boolean | null>(null);
    const [disableSubmitWarrantyOrder, setDisableSubmitWarrantyOrder] =
        useState(false);
    const partFormatter = usePartFormatter();

    const [prices, setPrices] = useState<{
        fullTotal: number;
        netTotal: number;
        discount: number;
        hidePrice: boolean;
    }>({
        fullTotal: 0,
        netTotal: 0,
        discount: 0,
        hidePrice: false,
    });

    function getCallStack() {
        console.trace();
        return new Error().stack;
    }

    /**
     * Primo caricamnto o quando cambia il current basket
     */
    const addColumnLogo: boolean =
        useBrands().currentBrand!.manufacturers.length > 1;

    useEffect(() => {
        // Se il currentBasket non è un object vuoto, recupera gli items
        if (Object.keys(currentBasket).length > 0) {
            // Mette in loading la pagina
            setLoading(true);
            listDisabledRow.current = [];

            // Chiama le API
            ServiceProvider.Basket.getBasketDetails(brand, currentLanguage)
                .then((result) => {
                    previousBasketId.current = result.basketId;
                    setBasketDetail(result);
                    setCurrency(result.total?.currency);
                    setShowDiscount(result.total?.showDiscount);
                    setItems(result.basketItems);

                    // With Price
                    // Se il timeout esisteva già lo elimino
                    if (loadPrice !== undefined) clearTimeout(loadPrice);

                    // Creare il time out con la function all'interno
                    var timeout = setTimeout(() => {
                        // Mette il loading per i prices
                        setLoadingPrices(true);
                        // Chiama le stesse API ma con i prezzi
                        callBasket("1");
                    }, 3000);

                    // const callBasketInternal = (
                    //     callPrice: "0" | "1" | "2" = "0"
                    // ): void => {
                    //     console.log(getCallStack()); 
                    //     ServiceProvider.Basket.getBasketDetails(
                    //         brand,
                    //         currentLanguage,
                    //         callPrice
                    //     )
                    //         .then((result) => {
                    //             if (
                    //                 result.basketId == previousBasketId.current
                    //             ) {
                    //                 if (callPrice === "1") {
                    //                     setBasketDetail(result);
                    //                     setCurrency(result.total?.currency);
                    //                     setShowDiscount(
                    //                         result.total?.showDiscount
                    //                     );
                    //                     setItems(result.basketItems);
                    //                 }
                    //                 if (callPrice === "2") {
                    //                     setItems(result.basketItems);
                    //                 } else {
                    //                     if (
                    //                         items !== undefined &&
                    //                         items !== null &&
                    //                         items.length > 0
                    //                     ) {
                    //                         setItems((prevItems) => {
                    //                             return prevItems?.map(
                    //                                 (item) => {
                    //                                     const value =
                    //                                         result.basketItems.find(
                    //                                             (x) =>
                    //                                                 x.rowId ===
                    //                                                 item.rowId
                    //                                         );

                    //                                     return item.rowId ===
                    //                                         value?.rowId
                    //                                         ? {
                    //                                               ...item,
                    //                                               partDescription:
                    //                                                   value.partDescription,
                    //                                               navContext:
                    //                                                   value.navContext,
                    //                                           }
                    //                                         : item;
                    //                                 }
                    //                             );
                    //                         });
                    //                     }
                    //                 }
                    //             }
                    //         })
                    //         .catch((error) => {
                    //             setError(error?.data?.title);
                    //             console.error(error);
                    //         })
                    //         .finally(() => {
                    //             setLoadingPrices(false);
                    //         });
                    // };

                    setLoading(false);
                })
                .catch((error) => console.error(error));
        }
    }, [currentBasket]);

    const reloadBasket = () => {
        callBasket("2");
        var timeout = setTimeout(() => {
            setLoadingPrices(true);
            callBasket("1");
        }, 3000);
    };

    const callBasket = (callPrice: "0" | "1" | "2" = "0"): void => {
         
        ServiceProvider.Basket.getBasketDetails(
            brand,
            currentLanguage,
            callPrice
        )
            .then((result) => {
                if (result.basketId == previousBasketId.current) {
                    if (callPrice === "1") {
                        setLoadingPrices(false);
                        setBasketDetail(result);
                        setCurrency(result.total?.currency);
                        setShowDiscount(result.total?.showDiscount);
                        setItems(result.basketItems);
                    }
                    if (callPrice === "2") {
                        setLoadingPrices(false);
                        setItems(result.basketItems);
                    } else {
                        if (
                            items != undefined &&
                            items != null &&
                            items.length > 0
                        ) {
                            setItems((prevItems) => {
                                return prevItems?.map((item) => {
                                    const value = result.basketItems.find(
                                        (x) => x.rowId === item.rowId
                                    );

                                    return item.rowId === value?.rowId
                                        ? {
                                              ...item,
                                              partDescription:
                                                  value.partDescription,
                                              navContext: value.navContext,
                                          }
                                        : item;
                                });
                            });
                        }
                    }
                }
            })
            .catch((error) => {
                setError(error?.data?.title);
                setLoadingPrices(false);
                console.error(error);
            }).finally(() => {
                setLoadingPrices(false);
            });;
    };

    const getCachedBasketDetails = () => {
        ServiceProvider.Basket.getCachedBasketDetails(brand, currentLanguage)
            .then((result) => {
                if (
                    items != undefined &&
                    items != null &&
                    items.length > 0
                ) {
                    setItems((prevItems) => {
                        return prevItems?.map((item) => {
                            const value = result.basketItems.find((x) => x.rowId === item.rowId);
                            return item.rowId === value?.rowId
                                ? {
                                      ...item,
                                      navContext: value.navContext,
                                  }
                                : item;
                        });
                    });
                    setBasketDetail({...basketDetail, operationsPermissions: result.operationsPermissions} as BasketDetail);
                }
            })
            .catch((error) => console.error(error));
    }

    // Cambiamento del basket
    useEffect(() => {
        setCurrentBasket(basketHook.currentBasket);
    }, [basketHook.currentBasket]);

    useEffect(() => {
        setLang(currentLanguage);
        if (items && items.length > 0) {
            callBasket("0");
        }
    }, [currentLanguage]);

    useEffect(() => {
        if (items && items.length > 0) {
            setLoadingPrices(true);
            callBasket("1");
        }
    }, [currentSite]);

    useEffect(() => {
        if (items) {
            const totals = items.reduce(
                (acc, item) => {
                    acc.fullTotal +=
                        (Math.round(Number(item.grossUnitPrice) * 100) / 100) *
                        item.qty;
                    acc.netTotal =
                        Math.round(Number(acc.netTotal) * 100) / 100 +
                        Math.round(Number(item.netTotalPrice) * 100) / 100;
                    acc.hidePrice = userInfo.userPermissions?.canViewPrices
                        ? false
                        : true;
                    return acc;
                },
                {
                    fullTotal: 0,
                    netTotal: 0,
                    discount: 0,
                    discountPercentage: 0,
                    hidePrice: false,
                }
            );

            if (totals.fullTotal > 0 && !totals.hidePrice) {
                // Evita divisioni per zero
                totals.discount = Number(totals.fullTotal - totals.netTotal);
                totals.discountPercentage = Number(
                    totals.discount / totals.fullTotal
                );
            } else {
                totals.hidePrice = true;
            }

            setPrices(totals);

            setDisableSubmitWarrantyOrder(
                items.some((x) => x.navContext === "")
            );
        }
    }, [items]);

    useEffect(() => {
        /**
         * Deve intercettare la chiusura della partDetail: 'closePartDetails'
         * controllare partDetailsProps.open === false, perché la 'closePartDetails' viene chiamata anche quando si apre
         * controllare partDetailOpen === true → campo che viene cambiato quando si apre la part detail inzia uguale a 'null'
         * se così mette il partDetailOpen a false e richiama la basket nella useEffect
         */
        if (partDetailsProps.open === false && partDetailOpen === true)
            setPartDetailOpen(false);
    }, [closePartDetails]);

    /**
     * Se partDetailOpen === false, richiama i prezzi, perché vuol dire che è stata chiusa la partDetail
     */
    useEffect(() => {
        if (partDetailOpen === false && partDetailsProps.reloadBasket) {
            setLoadingPrices(true);
            callBasket("1");
            setPartDetailOpen(null);
        }
    }, [partDetailOpen]);

    useEffect(() => {
        if (partDetailOpen === false) {
            callBasket("1");
        }
    }, [partDetailOpen]);

    useEffect(() => {
        if (partDetailsProps.open === false && partDetailOpen === true)
            setPartDetailOpen(false);
    }, [closePartDetails]);

    const handleChangeNavContext = (
        part: BasketItemDTO,
        forAllPart: string = "0"
    ) => {
        ServiceProvider.Basket.setNavContext(brand, part, forAllPart, lang)
            .then(() => {
                // Fa una chiamata alle API per recuperare tutto il basket e poter aggiornare i navContext
                //callBasket("0");
                // aggiorniamo tutto per gestire anche basketOperations
                getCachedBasketDetails();
            })
            .catch((error) => console.error(error));
    };

    // Funzione aggiornata per gestire la richiesta
    const handleChangeQty = (basketItem: BasketItemDTO) => {
        setItems((prevItems) =>
            prevItems.map((item) =>
                item.rowId === basketItem.rowId
                    ? {
                          ...item,
                          grossUnitPrice: undefined,
                          netTotalPrice: undefined,
                          availabilityStatus: undefined,
                      }
                    : item
            )
        );
        listDisabledRow.current.push(basketItem.rowId!);

        requestQueue
            .add(() =>
                ServiceProvider.Basket.setNewQty(brand, basketItem, lang)
            )
            .then((response: BasketItem) => {
                if (response.rowId && response.qty) {
                    setItems((prevItems) =>
                        prevItems.map((item) =>
                            item.rowId === response.rowId
                                ? {
                                      ...item,
                                      qty: response.qty,
                                      grossUnitPrice: response.grossUnitPrice,
                                      netTotalPrice: response.netTotalPrice,
                                      availabilityStatus:
                                          response.availabilityStatus,
                                      minOrderQty: response.minOrderQty,
                                      warningMinQty: response.warningMinQty,
                                      warningPackageQty: response.warningPackageQty,
                                  }
                                : item.code === response.code &&
                                  response.manufacturerCompanyCode ===
                                      item.manufacturerCompanyCode
                                ? {
                                      ...item,
                                      warningMinQty: response.warningMinQty,
                                      warningPackageQty: response.warningPackageQty,
                                  }
                                : item
                        )
                    );

                    const index = listDisabledRow.current.indexOf(
                        response.rowId
                    );
                    if (index > -1) listDisabledRow.current.splice(index, 1);
                    getCachedBasketDetails();
                }
            })
            .catch((error) => {
                console.error(
                    `Errore nell'aggiornare l'articolo ${basketItem.rowId}`,
                    error
                );
                setError(error?.data?.title);
                const index = listDisabledRow.current.indexOf(
                    basketItem.rowId!
                );
                if (index > -1) listDisabledRow.current.splice(index, 1);
            });
    };

    const handleDeleteRow = (rowId: string) => {
        ServiceProvider.Basket.RemoveBasketItem(brand, rowId, lang)
            .then((result) => {
                setItems((prevItems) =>
                    prevItems.filter((x) => x.rowId !== rowId)
                );
                getCachedBasketDetails()
            })
            .catch((error) => {
                console.error(error);
                setError(error?.data?.title);
            });
    };

    const handleActivateVertDotMenu = (event: any) => {
        setBasketListActionAnchorEl(event.target);
        event.preventDefault();
        event.stopPropagation();
    };

    const handleCloseOfferOrderWarrantyPopup = () => {
        setBasketOrderOfferWarrantyAnchorEl(null);
    };

    const handleCloseDotsPopup = () => {
        setBasketListActionAnchorEl(null);
    };

    const handleImportBasket = () => {
        setBasketListActionAnchorEl(null);
    };
    const onClearBasket = () => {
        ServiceProvider.Basket.ClearBasket(brand)
            .then((result) => {
                setItems([]);
            })
            .catch((error) => {
                console.error(error);
                setError(error?.data?.title);
            });
        setBasketListActionAnchorEl(null);
    };

    const onPrintBasket = () => {
        setBasketListActionAnchorEl(null);
        document.title = `${t("basket.title")}_${currentBasket.name}`;
        window.print();
        document.title = "Vandewiele Explorer";
    };

    const onTransferBasket = (username: string) => {
        ServiceProvider.Basket.TransferBasket(brand, username)
            .then((result) => {})
            .catch((error) => {
                console.error(error);
                setError(error?.data?.title);
            });
        setBasketListActionAnchorEl(null);
    };

    const handleAddPartByRef = (
        code: string,
        replacedCode:string,
        manufacturerCompanyCode: string,
        machine: string,
        tableCode: string,
        position: string
    ) => {
        const part: BasketItemDTO = {
            basketId: currentBasket.id,
            qty: 1,
            code: code,
            replacedCode:replacedCode,
            manufacturerCompanyCode: manufacturerCompanyCode,
            navContext: partFormatter.setNavContextByData(
                machine,
                tableCode,
                position
            ),
        };

        ServiceProvider.Basket.AddBasketItem(part)
            .then((response) => {
                callBasket("2");
                callBasket("1");
            })
            .catch((error) => {
                setError(
                    error.map((e: { errorCode: string | undefined }) =>
                        t(`basket.items.${e.errorCode}`)
                    )
                );
                console.error(error);
            });
    };

    return (
        <Root>
                <StylePathBox>
                    <BreadcrumbComponent />
                </StylePathBox>
                <Container>
                    <ContainerHeadBasket>
                        <BasketHeader basket={currentBasket} />

                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                        >
                            <BasketAddPartByRef callBack={handleAddPartByRef} />
                            <IconButton
                                className="osh-hint-basket-tools"
                                onClickCapture={(event) => {
                                    return handleActivateVertDotMenu(event);
                                }}
                                aria-label="delete"
                                color="primary"
                                sx={{ ml: 2 }}
                                disabled={loadingPrices}
                            >
                                <AppIconsMenuBurger
                                    sx={classes.dotMenu}
                                    color="primary"
                                />
                            </IconButton>
                        </Box>
                    </ContainerHeadBasket>
                    <TableAndPrices sx={classes.tableAndPrices}>
                        <PartList
                            items={items}
                            loading={loading}
                            emptyPage={BasketNoItemPage}
                            columns={[
                                ...(addColumnLogo
                                    ? [
                                          {
                                              name: "mcc",
                                              viewHeader: false,
                                              width: ColumnWidth.IconWidth,
                                              customComponent:
                                                  PartMccLogoComponent,
                                          },
                                      ]
                                    : []),
                                {
                                    name: "image",
                                    viewHeader: false,
                                    width: ColumnWidth.IconWidth,
                                    customComponent:
                                        PartSketchThumbnailComponent,
                                },
                                {
                                    name: "codeDescription",
                                    viewHeader: true,
                                    width: ColumnWidth.TextWidth,
                                    customComponent:
                                        CodeAndDescriptionComponent,
                                    additionalProps: {
                                        handleChangeNavContext,
                                        loadingPrices,
                                        openPartDetails,
                                        setPartDetailOpen,
                                    },
                                    align: ColumnAlign.Left,
                                },
                                {
                                    name: "withreplacement",
                                    viewHeader: false,
                                    width: ColumnWidth.IconWidth,
                                    customComponent: ReplaceIconComponent,
                                },
                                {
                                    name: "availabilityStatus",
                                    viewHeader: false,
                                    width: ColumnWidth.IconWidth,
                                    customComponent: AvaibilityIconComponent,
                                    additionalProps: {
                                        loadingPrices,
                                        listDisabledRow
                                    },
                                },
                                {
                                    name: "qty",
                                    viewHeader: true,
                                    width: ColumnWidth.ShortTextWidth,
                                    customComponent: QuantityComponent,
                                    additionalProps: {
                                        handleChangeQty,
                                        loadingPrices,
                                        listDisabledRow,
                                    },
                                },
                                {
                                    name: "discount",
                                    viewHeader: false,
                                    width: ColumnWidth.IconWidth,
                                    customComponent: DiscountComponent,
                                },
                                {
                                    name: "grossUnitPrice",
                                    viewHeader: true,
                                    width: ColumnWidth.ShortTextWidth,
                                    align: ColumnAlign.Right,
                                    customComponent: PriceFormatComponent,
                                    additionalProps: {
                                        loadingPrices,
                                        listDisabledRow,
                                    },
                                },
                                {
                                    name: "netTotalPrice",
                                    viewHeader: true,
                                    width: ColumnWidth.ShortTextWidth,
                                    align: ColumnAlign.Right,
                                    customComponent: PriceFormatComponent,
                                    additionalProps: {
                                        loadingPrices,
                                        listDisabledRow,
                                    },
                                },
                                {
                                    name: "deleteRow",
                                    viewHeader: false,
                                    width: ColumnWidth.IconWidth,
                                    customComponent: DeleteRowComponent,
                                    additionalProps: {
                                        handleDeleteRow,
                                        loadingPrices,
                                        listDisabledRow,
                                    },
                                },
                            ]}
                        />
                        {!isPilot() && (
                            <BasketOperations
                                currency={currency}
                                showDiscount={showDiscount}
                                items={items}
                                prices={prices}
                                operationsPermissions={basketDetail?.operationsPermissions}
                            />
                        )}
                        {items && items !== null && items.length > 0 && (
                            <BasketTotalPrice
                                currency={currency}
                                showDiscount={showDiscount}
                                fullTotal={prices.fullTotal}
                                netTotal={prices.netTotal}
                                discount={prices.discount}
                                hidePrice={prices.hidePrice}
                                loadingPrices={loadingPrices}
                            />
                        )}
                    </TableAndPrices>
                </Container>
                <BasketPageDotsMenu
                
                    anchorElement={basketListActionAnchorEl}
                    onClearBasket={onClearBasket}
                    onPrintBasket={onPrintBasket}
                    onTransferBasket={onTransferBasket}
                    onClose={handleCloseDotsPopup}
                    basketItems={items}
                    reloadPrice={reloadBasket}
                />
            </Root>
    );
};

export default BasketPage;
